import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleRoadWorthyCheckDto } from '../../dtos/create-vehicle-road-worthy-check.dto';
import { UpdateVehicleRoadWorthyCheckDto } from '../../dtos/update-vehicle-road-worthy-check.dto';
import { createVehicleRoadWorthyCheckSchema } from '../schemas/create-vehicle-road-worthy-check.schema';
import { updateVehicleRoadWorthyCheckSchema } from '../schemas/update-vehicle-road-worthy-check.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleRoadWorthyCheckDto | UpdateVehicleRoadWorthyCheckDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleRoadWorthyCheckSchema if 'id' is present
		validationResult = updateVehicleRoadWorthyCheckSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleRoadWorthyCheckSchema if 'id' is not present
		validationResult = createVehicleRoadWorthyCheckSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
